import Vue from "vue";

const SHOW_DELAY_MS = 200;
// Aborted navigations never reach afterEach, so never leave the bar stuck on.
const MAX_VISIBLE_MS = 15000;

export const navigationProgress = Vue.observable({ visible: false });

let showTimer = null;
let hideTimer = null;

export function startNavigationProgress() {
  clearTimeout(showTimer);
  clearTimeout(hideTimer);
  showTimer = setTimeout(() => {
    navigationProgress.visible = true;
  }, SHOW_DELAY_MS);
  hideTimer = setTimeout(stopNavigationProgress, MAX_VISIBLE_MS);
}

export function stopNavigationProgress() {
  clearTimeout(showTimer);
  clearTimeout(hideTimer);
  navigationProgress.visible = false;
}
